import { env } from "configs/EnvironmentConfig";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { create } from "xmlbuilder2";
import moment from "moment";

export const updateOrdersList = (list, newRow) => {
  return list.map((row) =>
    row.SampleId === newRow.SampleId ? { ...row, ...newRow } : row
  );
};

export const removeOrdersList = (list, newRow) => {
  return list.filter((row) => row.SampleId != newRow.SampleId);
};

//call an api to get a new sample id
export const fetchNewSampleId = async () => {
  try {
    const response = await fetch(env.API_ENDPOINT_URL + "/getSampleId", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data.sampleId;
  } catch (error) {
    console.error("Error fetching new sample ID:", error);
    return null;
  }
};

export const updatePosMachinePrintState = async (value) => {
  try {
    const response = await fetch(
      env.API_ENDPOINT_URL + "/update-pos-machine-print-state",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        },
        body: JSON.stringify(value),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating the state:", error);
    return null;
  }
};

export const generateXmlFileForReceipt = async (
  row,
  printType = "NotDirectPrint"
) => {
  // 1. Create the base XML structure
  const root = create({ version: "1.0", encoding: "UTF-8" }).ele("Invoice");

  // 2. Add main invoice details
  root.ele("Invoice_Type").txt("Invoice");
  root.ele("Reference_Number").txt(row.SampleIdReference);
  root
    .ele("Invoice_Date")
    .txt(moment(row.insertedTimeStamp, "YYYYMMDDHHmmss").format("DD.MM.YYYY"));
  root.ele("Customer_Code").txt(row.PatientId);
  root
    .ele("Customer_Name")
    .txt(row.FirstName + " " + row.MiddleName + " " + row.LastName);
  root
    .ele("Customer_TIN")
    .txt(row.ClientTin?.length >= 10 ? row.ClientTin : " ");
  root.ele("Payment_Type").txt(row.PaymentType == "Credit" ? "Credit" : "Cash");
  root
    .ele("Invoice_DiscOrAdd_Amount")
    .txt(row.discount ? row.discount.toFixed(2) : 0);

  if (printType === "NotDirectPrint") {
    // 3. Dynamically add each line item by mapping over the array
    row.orderedTestsAndPanels.forEach((item) => {
      const itemNode = root.ele("Line_Items");
      itemNode.ele("Item_ID").txt(item.id);
      itemNode.ele("Item_Description").txt(item.PaneltestShortName);
      itemNode.ele("Item_Quantity").txt(1);
      itemNode.ele("Item_UOM").txt("Piece");
      itemNode.ele("Item_Unit_Price").txt(item.PaneltestPrice.toFixed(2));
      itemNode.ele("Item_Tax_Percent").txt("0");
      // Handle potentially empty discount field
      itemNode
        .ele("Item_DiscOrAdd_Amount")
        .txt(item.discount ? item.discount.toFixed(2) : 0);
    });
  } else {
    // 3. Dynamically add each line item by mapping over the array
    row.panelsAndTests.forEach((item) => {
      const itemNode = root.ele("Line_Items");
      itemNode.ele("Item_ID").txt(item.item_id);
      itemNode.ele("Item_Description").txt(item.item_shortname);
      itemNode.ele("Item_Quantity").txt(1);
      itemNode.ele("Item_UOM").txt("Piece");
      itemNode
        .ele("Item_Unit_Price")
        .txt(parseFloat(item[row.priceType]).toFixed(2));
      itemNode.ele("Item_Tax_Percent").txt("0");
      // Handle potentially empty discount field
      itemNode
        .ele("Item_DiscOrAdd_Amount")
        .txt(item.item_discount ? item.discount.toFixed(2) : 0);
    });
  }

  // 4. Convert the XML object to a formatted string
  const xmlString = root.end({ prettyPrint: true });

  return xmlString;
};
